export enum NationalQualification {
  PresentationReady = "PresentationReady",
  Qualified = "Qualified",
  Unqualified = "Unqualified",
  Expired = "Expired"
}
